'use client';
import { useEffect, useContext } from 'react';
import { useActor } from '@xstate/react';
import { GlobalStateContext } from '../state/app/index';
import { getEntitiesNotFound } from '../state/stateUtils';

const DryDebugger = (props) => {
  const globalServices = useContext(GlobalStateContext);
  
  // Guard against undefined context (e.g., during SSR or before provider mounts)
  if (!globalServices || !globalServices.appState) {
    return null;
  }
  
  const [appState] = useActor(globalServices.appState);
  const {
    context: {
      applicationTitle,
      breakpoint,
      notebooks,
      selectedNotebook,
      areasOfFocusCollections,
      notes,
      selectedNote,
      userSettings,
      editorType,
      selectedAreaOfFocus,
    },
  } = appState;

  useEffect(() => {
    // Create the Drynotes debug object
    if (typeof window !== 'undefined') {
      window.DRY = window.DRY || {};
      window.DRY.debug = {
        account: {
          userID: '',
        },
        userSettings: userSettings,
        areasOfFocus: {
          totalCount: areasOfFocusCollections
            ? Object.keys(areasOfFocusCollections).length
            : 0,
          selectedAreasOfFocusCollection: selectedAreaOfFocus,
        },
        notebook: {
          selectedNotebook: selectedNotebook,
        },
        notes: {
          noteCount: notes ? Object.keys(notes).length : 0,
          selectedNoteId: selectedNote ? selectedNote.note_id : null,
          selectedNoteObject: selectedNote,
        },
        tabs: {
          rendered: [],
          selectedAreaOfFocusId: selectedAreaOfFocus
            ? selectedAreaOfFocus.area_of_focus_collection_id
            : null,
          // shouldHaveBeenRendered: areasOfFocusCollectionsState.context.orderOfItems?.length,
          // notFound: getEntitiesNotFound(notesState.context?.notes, areasOfFocusCollectionsState.context?.selectedAreasOfFocusCollection?.notes),
          selectedNoteId: selectedNote ? selectedNote.note_id : null,
          // areaOfFocusSelectedNoteId: selectedAreaOfFocus,
          // selectedNoteMatch: notesState.context.selectedNoteId === areasOfFocusCollectionsState.context.selectedNote,
        },
        client: {
          breakpoint: breakpoint,
          applicationTitle: applicationTitle,
          editorType: editorType,
        },
        keyboardEvents: () => {
          const keyEvents = (type, event) => {
            console.table([
              {
                type: 'keyEvents',
                eventType: type,
                key: event.key,
                code: event.keyCode,
                event,
              },
            ]);
          };

          // Triggers when key is depressed
          document.addEventListener('keydown', (event) => {
            keyEvents('keydown', event);
          });

          // Triggers when key is released
          document.addEventListener('keyup', (event) => {
            keyEvents('keyup', event);
          });
        },
      };
    }
  }, [
    appState,
    applicationTitle,
    areasOfFocusCollections,
    breakpoint,
    editorType,
    notes,
    selectedAreaOfFocus,
    selectedNote,
    selectedNotebook,
    userSettings,
  ]);

  return null;
};

export default DryDebugger;
